import React, { memo, useEffect, useState } from "react";

function ModalProducto({
  mostrar,
  producto,
  cortesiaProducto,
  extrasSeleccionados,
  comentarioProducto = "",
  extrasCortesiaSeleccionados = [],
  comentarioCortesia = "",
  opcionesSeleccionadas = {},
  estadoTienda = null,
  onCambiarComentario = () => {},
  onCambiarComentarioCortesia = () => {},
  onToggleExtra,
  onToggleExtraCortesia = () => {},
  onCambiarOpcionSinCosto = () => {},
  onCerrar,
  onConfirmar,
}) {
  const imagenInicialNoValida =
    !producto?.imagen ||
    producto?.imagen?.includes("via.placeholder.com") ||
    producto?.imagen?.trim() === "";

  const imagenCortesiaInicialNoValida =
    !cortesiaProducto?.imagen ||
    cortesiaProducto?.imagen?.includes("via.placeholder.com") ||
    cortesiaProducto?.imagen?.trim() === "";

  const [imagenFallida, setImagenFallida] = useState(imagenInicialNoValida);
  const [imagenCortesiaFallida, setImagenCortesiaFallida] = useState(
    imagenCortesiaInicialNoValida,
  );

  useEffect(() => {
    setImagenFallida(imagenInicialNoValida);
  }, [producto?.imagen]);

  useEffect(() => {
    setImagenCortesiaFallida(imagenCortesiaInicialNoValida);
  }, [cortesiaProducto?.imagen]);

  if (!mostrar || !producto) return null;

  const totalProducto =
    producto.precio +
    extrasSeleccionados.reduce((sum, e) => sum + (e.precio || 0), 0);

  const totalExtrasCortesia = extrasCortesiaSeleccionados.reduce(
    (sum, e) => sum + (e.precio || 0),
    0,
  );

  const totalFinal = totalProducto + totalExtrasCortesia;

  const opcionesSinCosto = producto.opcionesSinCosto || [];

  const tiendaCerrada = estadoTienda && estadoTienda.abierta === false;

  const renderImagenPlaceholder = (alto = "230px") => (
    <div
      style={{
        width: "100%",
        height: alto,
        background: "linear-gradient(135deg, #fff7ec 0%, #f0ddc5 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "8px",
      }}
    >
      <img
        src="/logo-mitico.png"
        alt="Mítico"
        style={{
          maxWidth: "150px",
          maxHeight: "70px",
          objectFit: "contain",
        }}
      />

      <span
        style={{
          fontSize: "12px",
          fontWeight: "900",
          color: "#9a5c1f",
          letterSpacing: "0.2px",
        }}
      >
        Imagen próximamente
      </span>
    </div>
  );

  return (
    <>
      <style>
        {`
          @keyframes modalProductoEntrada {
            from {
              opacity: 0;
              transform: translateY(26px) scale(0.98);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
        `}
      </style>

      <div
        onClick={onCerrar}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.52)",
          zIndex: 9999,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          boxSizing: "border-box",
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "100%",
            maxWidth: "520px",
            backgroundColor: "#fff",
            borderTopLeftRadius: "28px",
            borderTopRightRadius: "28px",
            overflow: "hidden",
            maxHeight: "94vh",
            overflowY: "auto",
            boxSizing: "border-box",
            animation: "modalProductoEntrada 0.24s ease-out",
            boxShadow: "0 -10px 32px rgba(0,0,0,0.22)",
          }}
        >
          <div
            style={{
              width: "42px",
              height: "5px",
              borderRadius: "999px",
              backgroundColor: "#ddd",
              margin: "10px auto 8px auto",
            }}
          />

          <div
            style={{
              position: "relative",
              backgroundColor: "#f4f1ed",
            }}
          >
            {imagenFallida ? (
              renderImagenPlaceholder("230px")
            ) : (
              <img
                src={producto.imagen}
                alt={producto.nombre}
                loading="lazy"
                decoding="async"
                onError={() => setImagenFallida(true)}
                style={{
                  width: "100%",
                  height: "230px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            )}

            <button
              type="button"
              onClick={onCerrar}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: "rgba(255,255,255,0.92)",
                color: "#111",
                fontSize: "18px",
                fontWeight: "900",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.16)",
              }}
            >
              ×
            </button>
          </div>

          <div
            style={{
              padding: "20px",
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "12px",
                alignItems: "flex-start",
                marginBottom: "10px",
              }}
            >
              <div style={{ minWidth: 0 }}>
                <h2
                  style={{
                    margin: "0 0 6px 0",
                    fontSize: "23px",
                    fontWeight: "950",
                    wordBreak: "break-word",
                    color: "#111",
                    lineHeight: "1.15",
                  }}
                >
                  {producto.nombre}
                </h2>

                <p
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                    lineHeight: "1.45",
                  }}
                >
                  {producto.descripcion || "Platillo disponible en Mítico."}
                </p>
              </div>

              <div
                style={{
                  backgroundColor: "#111",
                  color: "#fff",
                  borderRadius: "16px",
                  padding: "9px 12px",
                  fontSize: "14px",
                  fontWeight: "950",
                  whiteSpace: "nowrap",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.14)",
                }}
              >
                ${Number(producto.precio || 0).toFixed(0)}
              </div>
            </div>

            {opcionesSinCosto.length > 0 && (
              <div style={sectionStyle}>
                <div style={sectionHeaderStyle}>
                  <span>Opciones incluidas</span>
                  <small style={sectionSmallStyle}>Sin costo extra</small>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                  }}
                >
                  {opcionesSinCosto.map((grupo, idx) => {
                    const requerido = grupo.requerido || grupo.required;
                    const tipo = grupo.tipo || "unica";
                    const seleccionActual = opcionesSeleccionadas[grupo.nombre];

                    return (
                      <div
                        key={idx}
                        style={{
                          backgroundColor: "#fafafa",
                          border: "1px solid #eeeeee",
                          borderRadius: "16px",
                          padding: "13px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "950",
                            marginBottom: "9px",
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "8px",
                          }}
                        >
                          <span>
                            {grupo.nombre}{" "}
                            {requerido && (
                              <span style={{ color: "#c5221f" }}>*</span>
                            )}
                          </span>

                          <span
                            style={{
                              fontSize: "11px",
                              color: "#777",
                              fontWeight: "800",
                            }}
                          >
                            {tipo === "multiple" ? "Varias" : "Una"}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          {(grupo.opciones || []).map((opcion) => {
                            const activo =
                              tipo === "multiple"
                                ? Array.isArray(seleccionActual) &&
                                  seleccionActual.includes(opcion)
                                : seleccionActual === opcion;

                            return (
                              <button
                                key={opcion}
                                type="button"
                                onClick={() =>
                                  onCambiarOpcionSinCosto(grupo, opcion)
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "10px",
                                  padding: "12px",
                                  borderRadius: "13px",
                                  border: activo
                                    ? "2px solid #111"
                                    : "1px solid #ddd",
                                  backgroundColor: activo ? "#fff" : "#fdfdfd",
                                  cursor: "pointer",
                                  width: "100%",
                                  boxSizing: "border-box",
                                  boxShadow: activo
                                    ? "0 4px 10px rgba(0,0,0,0.06)"
                                    : "none",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "800",
                                  }}
                                >
                                  {opcion}
                                </span>

                                <span
                                  style={{
                                    width: "22px",
                                    height: "22px",
                                    borderRadius: "50%",
                                    backgroundColor: activo
                                      ? "#137333"
                                      : "#eeeeee",
                                    color: activo ? "#fff" : "#999",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    fontWeight: "950",
                                  }}
                                >
                                  {activo
                                    ? "✓"
                                    : tipo === "multiple"
                                      ? "+"
                                      : ""}
                                </span>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {producto.extras && producto.extras.length > 0 && (
              <div style={sectionStyle}>
                <div style={sectionHeaderStyle}>
                  <span>Extras con costo</span>
                  <small style={sectionSmallStyle}>Opcionales</small>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "9px",
                  }}
                >
                  {producto.extras.map((extra, idx) => {
                    const activo = extrasSeleccionados.some(
                      (e) => e.nombre === extra.nombre,
                    );

                    return (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => onToggleExtra(extra)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "10px",
                          padding: "13px",
                          borderRadius: "14px",
                          border: activo ? "2px solid #111" : "1px solid #ddd",
                          backgroundColor: activo ? "#f7f3ec" : "#fff",
                          cursor: "pointer",
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                      >
                        <span style={{ fontSize: "14px", fontWeight: "800" }}>
                          {extra.nombre}
                        </span>

                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "950",
                            color: "#111",
                          }}
                        >
                          +${Number(extra.precio || 0).toFixed(0)}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            <div style={sectionStyle}>
              <div style={sectionHeaderStyle}>
                <span>Comentarios para cocina</span>
                <small style={sectionSmallStyle}>Opcional</small>
              </div>

              <textarea
                value={comentarioProducto}
                onChange={(e) => onCambiarComentario(e.target.value)}
                placeholder="Ej. sin cebolla, salsa aparte, poco picante..."
                rows="3"
                style={{
                  width: "100%",
                  padding: "13px",
                  borderRadius: "14px",
                  border: "1px solid #ddd",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  resize: "vertical",
                  backgroundColor: "#fff",
                  outline: "none",
                }}
              />
            </div>

            {cortesiaProducto && (
              <div
                style={{
                  marginBottom: "18px",
                  padding: "15px",
                  borderRadius: "18px",
                  background:
                    "linear-gradient(135deg, #fff8e6 0%, #fff2cf 100%)",
                  border: "1px solid #ffd27a",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "950",
                    color: "#b06000",
                    marginBottom: "10px",
                  }}
                >
                  🎁 Esta promoción incluye
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    marginBottom: "14px",
                  }}
                >
                  {imagenCortesiaFallida ? (
                    <div
                      style={{
                        width: "58px",
                        height: "58px",
                        borderRadius: "12px",
                        backgroundColor: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        border: "1px solid #f0d58c",
                      }}
                    >
                      🎁
                    </div>
                  ) : (
                    <img
                      src={cortesiaProducto.imagen}
                      alt={cortesiaProducto.nombre}
                      loading="lazy"
                      decoding="async"
                      onError={() => setImagenCortesiaFallida(true)}
                      style={{
                        width: "58px",
                        height: "58px",
                        borderRadius: "12px",
                        objectFit: "cover",
                        backgroundColor: "#eee",
                        flexShrink: 0,
                      }}
                    />
                  )}

                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: "15px",
                        fontWeight: "950",
                        color: "#111",
                        wordBreak: "break-word",
                      }}
                    >
                      {cortesiaProducto.nombre}
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "2px",
                        lineHeight: "1.3",
                      }}
                    >
                      1 pieza de cortesía al agregar este producto.
                    </div>

                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "950",
                        color: "#137333",
                        marginTop: "4px",
                      }}
                    >
                      Producto base $0 MXN
                    </div>
                  </div>
                </div>

                {cortesiaProducto.extras &&
                  cortesiaProducto.extras.length > 0 && (
                    <div style={{ marginTop: "12px" }}>
                      <h4
                        style={{
                          margin: "0 0 10px 0",
                          fontSize: "14px",
                          fontWeight: "950",
                          color: "#111",
                        }}
                      >
                        Personaliza tu cortesía
                      </h4>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        {cortesiaProducto.extras.map((extra, idx) => {
                          const activo = extrasCortesiaSeleccionados.some(
                            (e) => e.nombre === extra.nombre,
                          );

                          return (
                            <button
                              key={idx}
                              type="button"
                              onClick={() => onToggleExtraCortesia(extra)}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                                padding: "12px",
                                borderRadius: "13px",
                                border: activo
                                  ? "2px solid #111"
                                  : "1px solid #ddd",
                                backgroundColor: activo ? "#fff" : "#fffaf0",
                                cursor: "pointer",
                                width: "100%",
                                boxSizing: "border-box",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "800",
                                }}
                              >
                                {extra.nombre}
                              </span>

                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "950",
                                }}
                              >
                                +${Number(extra.precio || 0).toFixed(0)}
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                <div style={{ marginTop: "14px" }}>
                  <h4
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      fontWeight: "950",
                      color: "#111",
                    }}
                  >
                    Comentario para la cortesía
                  </h4>

                  <textarea
                    value={comentarioCortesia}
                    onChange={(e) =>
                      onCambiarComentarioCortesia(e.target.value)
                    }
                    placeholder="Ej. sin queso, salsa aparte, poco picante..."
                    rows="3"
                    style={{
                      width: "100%",
                      padding: "12px",
                      borderRadius: "13px",
                      border: "1px solid #ddd",
                      boxSizing: "border-box",
                      fontFamily: "inherit",
                      fontSize: "14px",
                      resize: "vertical",
                      backgroundColor: "#fff",
                    }}
                  />
                </div>
              </div>
            )}

            <div
              style={{
                position: "sticky",
                bottom: 0,
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.86) 0%, #fff 35%)",
                paddingTop: "12px",
                marginTop: "4px",
              }}
            >
              {tiendaCerrada && (
                <div
                  style={{
                    backgroundColor: "#fff8e1",
                    border: "1px solid #ffe0a3",
                    borderRadius: "14px",
                    padding: "11px 12px",
                    marginBottom: "10px",
                    color: "#7a4b00",
                    fontSize: "12px",
                    fontWeight: "800",
                    lineHeight: "1.45",
                  }}
                >
                  {estadoTienda?.mensaje ||
                    "Por ahora no estamos recibiendo pedidos. Puedes revisar el menú y volver en nuestro horario de atención."}

                  {estadoTienda?.reaperturaTexto && (
                    <div
                      style={{
                        marginTop: "4px",
                        fontWeight: "950",
                      }}
                    >
                      {estadoTienda.reaperturaTexto}
                    </div>
                  )}
                </div>
              )}

              <button
                type="button"
                disabled={tiendaCerrada}
                onClick={tiendaCerrada ? undefined : onConfirmar}
                style={{
                  width: "100%",
                  background: tiendaCerrada
                    ? "#bbb"
                    : "linear-gradient(135deg, #111 0%, #1f1f1f 60%, #3a2a1b 100%)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "16px",
                  padding: "16px",
                  fontSize: "16px",
                  fontWeight: "950",
                  cursor: tiendaCerrada ? "not-allowed" : "pointer",
                  boxSizing: "border-box",
                  boxShadow: tiendaCerrada
                    ? "none"
                    : "0 7px 18px rgba(0,0,0,0.22)",
                }}
              >
                {tiendaCerrada
                  ? "Tienda cerrada por ahora"
                  : `Agregar al carrito • $${Number(totalFinal || 0).toFixed(2)}`}
              </button>

              <button
                type="button"
                onClick={onCerrar}
                style={{
                  width: "100%",
                  marginTop: "10px",
                  backgroundColor: "#fff",
                  color: "#111",
                  border: "1px solid #ddd",
                  borderRadius: "16px",
                  padding: "14px",
                  fontSize: "14px",
                  fontWeight: "800",
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const sectionStyle = {
  marginBottom: "18px",
  padding: "14px",
  borderRadius: "18px",
  backgroundColor: "#fbfbfb",
  border: "1px solid #eeeeee",
};

const sectionHeaderStyle = {
  margin: "0 0 11px 0",
  fontSize: "15px",
  fontWeight: "950",
  color: "#111",
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
  alignItems: "center",
};

const sectionSmallStyle = {
  fontSize: "11px",
  fontWeight: "800",
  color: "#777",
  whiteSpace: "nowrap",
};

export default memo(ModalProducto);
